module.exports = __webpack_public_path__ + "static/icon-hex-globe-loc-4-610158216f50f2bcbcb622a9c992b284.svg";